import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "profil-page" }
const _hoisted_2 = {
  key: 1,
  class: "profil"
}
const _hoisted_3 = { class: "cover" }
const _hoisted_4 = { class: "cover-row" }
const _hoisted_5 = { class: "avatar-xl" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "avatar-ini"
}
const _hoisted_8 = { class: "cover-info" }
const _hoisted_9 = { class: "cover-name" }
const _hoisted_10 = { class: "cover-role" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "sep"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "cover-stats" }
const _hoisted_16 = {
  key: 0,
  class: "stat"
}
const _hoisted_17 = { class: "ml-1" }
const _hoisted_18 = {
  key: 1,
  class: "stat"
}
const _hoisted_19 = {
  key: 2,
  class: "stat"
}
const _hoisted_20 = { class: "ml-1" }
const _hoisted_21 = { class: "cover-actions" }
const _hoisted_22 = { class: "content" }
const _hoisted_23 = { class: "info-grid" }
const _hoisted_24 = { class: "card-h" }
const _hoisted_25 = { class: "card-fields" }
const _hoisted_26 = { class: "fld-label" }
const _hoisted_27 = { class: "side" }
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "card-h" }
const _hoisted_30 = {
  class: "card-ic",
  style: {"background":"#fff7ed","color":"#f59e0b"}
}
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "card" }
const _hoisted_33 = { class: "card-h" }
const _hoisted_34 = {
  class: "card-ic",
  style: {"background":"#f5f3ff","color":"#8b5cf6"}
}
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = { class: "sig-view" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "sig-view-row" }
const _hoisted_39 = { class: "sig-saved" }
const _hoisted_40 = { class: "sig-pad-wrap" }
const _hoisted_41 = {
  key: 0,
  class: "sig-hint"
}
const _hoisted_42 = { class: "sig-actions" }
const _hoisted_43 = {
  class: "d-flex align-center",
  style: {"gap":"6px"}
}
const _hoisted_44 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_45 = { class: "dlg-head" }
const _hoisted_46 = { class: "dlg-head-ic" }
const _hoisted_47 = { class: "modif-inner" }
const _hoisted_48 = { class: "modif-toprow" }
const _hoisted_49 = { class: "modif-tip" }
const _hoisted_50 = {
  class: "pnl-ic",
  style: {"background":"#fff1ec","color":"#ff5722"}
}
const _hoisted_51 = { class: "modif-grid" }
const _hoisted_52 = {
  class: "pnl-ic",
  style: {"background":"#f5f3ff","color":"#8b5cf6"}
}
const _hoisted_53 = { class: "modif-grid" }
const _hoisted_54 = {
  class: "pnl-ic",
  style: {"background":"#fef2f2","color":"#ef4444"}
}
const _hoisted_55 = { class: "modif-grid" }
const _hoisted_56 = {
  class: "pnl-ic",
  style: {"background":"#ecfdf5","color":"#16a34a"}
}
const _hoisted_57 = { class: "modif-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "#ff5722",
          class: "mb-4",
          rounded: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.profil)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "cover-band" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.profil.PozaBase64)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.profil.PozaBase64,
                      class: "avatar-img",
                      alt: "poza"
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.initiale), 1)),
                _createElementVNode("button", {
                  class: "cam-btn",
                  title: "Schimbă poza",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerPoza && _ctx.triggerPoza(...args)))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "15",
                    color: "#fff"
                  }, {
                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                      _createTextVNode("mdi-camera", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("input", {
                  ref: "pozaInput",
                  type: "file",
                  accept: "image/jpeg,image/png",
                  class: "d-none",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPozaSelected && _ctx.onPozaSelected(...args)))
                }, null, 544)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.numeComplet), 1),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.profil.Functie)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.profil.Functie), 1))
                    : _createCommentVNode("", true),
                  (_ctx.profil.Functie && _ctx.profil.Departament)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "•"))
                    : _createCommentVNode("", true),
                  (_ctx.profil.Departament)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.profil.Departament), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.profil.Functie && !_ctx.profil.Departament)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Angajat"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.profil.Marca)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: "#ff5722",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                            _createTextVNode("mdi-badge-account-horizontal-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[43] || (_cache[43] = _createTextVNode("Marcă ", -1)),
                        _createElementVNode("b", _hoisted_17, _toDisplayString(_ctx.profil.Marca), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.profil.ZileConcediu != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: "#0ea5e9",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                            _createTextVNode("mdi-umbrella-beach", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("b", null, _toDisplayString(_ctx.profil.ZileConcediu), 1),
                        _cache[45] || (_cache[45] = _createTextVNode(" zile concediu", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.vechimeText)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: "#16a34a",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                            _createTextVNode("mdi-calendar-check", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[47] || (_cache[47] = _createTextVNode("Angajat din ", -1)),
                        _createElementVNode("b", _hoisted_20, _toDisplayString(_ctx.vechimeText), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_v_btn, {
                  class: "btn-modif",
                  "prepend-icon": "mdi-file-document-edit-outline",
                  onClick: _ctx.openModif
                }, {
                  default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                    _createTextVNode("Solicită modificare", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("main", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectiuni, (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: s.key,
                  class: _normalizeClass(["card", { wide: s.key === 'personale' }])
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", {
                      class: "card-ic",
                      style: _normalizeStyle({ background: s.soft, color: s.color })
                    }, [
                      _createVNode(_component_v_icon, { size: "15" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(s.icon), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ], 4),
                    _createTextVNode(" " + _toDisplayString(s.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.rows, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c.label,
                        class: "fld"
                      }, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(c.label), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["fld-value", { mono: _ctx.monoField(c.label) }])
                        }, _toDisplayString(c.value), 3)
                      ]))
                    }), 128))
                  ])
                ], 2))
              }), 128))
            ]),
            _createElementVNode("aside", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_v_icon, { size: "15" }, {
                      default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                        _createTextVNode("mdi-card-account-mail-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[51] || (_cache[51] = _createTextVNode(" Date de contact", -1)),
                  _cache[52] || (_cache[52] = _createElementVNode("span", { class: "edit-hint" }, "Editabil", -1))
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[54] || (_cache[54] = _createElementVNode("p", { class: "card-cap" }, "Adresa de email și telefonul tău, vizibile pentru HR.", -1)),
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.editValid,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editValid) = $event)),
                    ref: "editForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.editData.Email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editData.Email) = $event)),
                        "prepend-inner-icon": "mdi-email-outline",
                        label: "Email",
                        variant: "outlined",
                        density: "comfortable",
                        "hide-details": "auto",
                        class: "mb-3",
                        rules: [_ctx.emailRule],
                        type: "email"
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.editData.Telefon,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editData.Telefon) = $event)),
                        "prepend-inner-icon": "mdi-phone-outline",
                        label: "Telefon",
                        variant: "outlined",
                        density: "comfortable",
                        "hide-details": "auto"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.saveMsg)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: _ctx.saveMsgType,
                        variant: "tonal",
                        density: "compact",
                        class: "mt-3",
                        closable: "",
                        "onClick:close": _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveMsg = ''))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.saveMsg), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    block: "",
                    class: "btn-save mt-3",
                    loading: _ctx.saveLoading,
                    disabled: !_ctx.editValid,
                    "prepend-icon": "mdi-content-save-outline",
                    onClick: _ctx.salveaza
                  }, {
                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                      _createTextVNode("Salvează", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, [
                    _createVNode(_component_v_icon, { size: "15" }, {
                      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                        _createTextVNode("mdi-draw-pen", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[56] || (_cache[56] = _createTextVNode(" Semnătură ", -1))
                ]),
                _createElementVNode("div", _hoisted_35, [
                  (_ctx.profil.SemnaturaBase64 && !_ctx.semnEditMode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("img", {
                            src: _ctx.profil.SemnaturaBase64,
                            alt: "semnătură"
                          }, null, 8, _hoisted_37)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "#16a34a",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[58] || (_cache[58] = _createTextVNode("Salvată", -1))
                          ]),
                          _createVNode(_component_v_btn, {
                            size: "small",
                            variant: "text",
                            class: "btn-resign",
                            "prepend-icon": "mdi-refresh",
                            onClick: _ctx.startResign
                          }, {
                            default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                              _createTextVNode("Reface", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("canvas", {
                            ref: "sigCanvas",
                            class: "sig-canvas",
                            onPointerdown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sigDown && _ctx.sigDown(...args))),
                            onPointermove: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sigMove && _ctx.sigMove(...args))),
                            onPointerup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sigUp && _ctx.sigUp(...args))),
                            onPointerleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sigUp && _ctx.sigUp(...args)))
                          }, null, 544),
                          (!_ctx.sigHasDrawn)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createVNode(_component_v_icon, {
                                  size: "15",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                    _createTextVNode("mdi-gesture", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[61] || (_cache[61] = _createTextVNode("Semnează aici", -1))
                              ]))
                            : _createCommentVNode("", true),
                          _cache[62] || (_cache[62] = _createElementVNode("div", { class: "sig-baseline" }, null, -1))
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            variant: "text",
                            disabled: !_ctx.sigHasDrawn,
                            onClick: _ctx.sigClear
                          }, {
                            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                              _createTextVNode("Șterge", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled", "onClick"]),
                          _createElementVNode("div", _hoisted_43, [
                            (_ctx.profil.SemnaturaBase64)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  size: "small",
                                  variant: "text",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.semnEditMode = false))
                                }, {
                                  default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                    _createTextVNode("Renunță", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_btn, {
                              size: "small",
                              class: "btn-mini",
                              loading: _ctx.semnLoading,
                              disabled: !_ctx.sigHasDrawn,
                              onClick: _ctx.sigSave
                            }, {
                              default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                _createTextVNode("Salvează", -1)
                              ]))]),
                              _: 1
                            }, 8, ["loading", "disabled", "onClick"])
                          ])
                        ])
                      ], 64))
                ])
              ])
            ])
          ])
        ]))
      : (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createVNode(_component_v_icon, {
              size: "42",
              color: "#cbd5e1"
            }, {
              default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                _createTextVNode("mdi-account-question-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[67] || (_cache[67] = _createElementVNode("p", null, "Profilul nu a putut fi încărcat.", -1))
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogModif,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.dialogModif) = $event)),
      "max-width": "760",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "modif-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                    _createTextVNode("mdi-file-document-edit-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[69] || (_cache[69] = _createElementVNode("div", { class: "dlg-head-txt" }, [
                _createElementVNode("div", { class: "dlg-title" }, "Solicită modificare date"),
                _createElementVNode("div", { class: "dlg-desc" }, "Precompletat cu datele tale. Modifică ce vrei — cererea merge la HR.")
              ], -1)),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogModif = false))
              })
            ]),
            _createVNode(_component_v_card_text, { class: "pa-0 modif-body" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.modif.Mesaj,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modif.Mesaj) = $event)),
                      label: "Mesaj pentru HR *",
                      variant: "outlined",
                      density: "comfortable",
                      rows: "2",
                      "auto-grow": "",
                      "hide-details": "",
                      class: "modif-msg"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.modif.PrioritateID,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modif.PrioritateID) = $event)),
                      items: _ctx.prioritati,
                      "item-title": "Name",
                      "item-value": "ID",
                      label: "Prioritate",
                      variant: "outlined",
                      density: "comfortable",
                      "hide-details": "",
                      class: "modif-prio"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_v_icon, {
                      size: "15",
                      color: "#94a3b8",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                        _createTextVNode("mdi-gesture-tap", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[71] || (_cache[71] = _createTextVNode(" Deschide doar secțiunile pe care vrei să le corectezi. ", -1))
                  ]),
                  _createVNode(_component_v_expansion_panels, {
                    modelValue: _ctx.modifPanels,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.modifPanels) = $event)),
                    multiple: "",
                    variant: "accordion",
                    class: "modif-panels"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, { value: "personale" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_50, [
                                _createVNode(_component_v_icon, { size: "15" }, {
                                  default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                    _createTextVNode("mdi-account-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _cache[73] || (_cache[73] = _createElementVNode("span", { class: "pnl-title" }, "Date personale", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Name,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modif.Name) = $event)),
                                  label: "Prenume",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Surname,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modif.Surname) = $event)),
                                  label: "Nume",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.BornDate,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modif.BornDate) = $event)),
                                  label: "Data nașterii",
                                  type: "date",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.modif.Sex,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modif.Sex) = $event)),
                                  items: _ctx.sexItems,
                                  "item-title": "text",
                                  "item-value": "value",
                                  label: "Sex",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue", "items"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panel, { value: "act" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_52, [
                                _createVNode(_component_v_icon, { size: "15" }, {
                                  default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                    _createTextVNode("mdi-card-account-details-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _cache[75] || (_cache[75] = _createElementVNode("span", { class: "pnl-title" }, "Act de identitate", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.DocIdentTip,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modif.DocIdentTip) = $event)),
                                  label: "Tip act",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.DocIdentSerie,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modif.DocIdentSerie) = $event)),
                                  label: "Serie",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.DocIdentNo,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modif.DocIdentNo) = $event)),
                                  label: "Număr",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Cnp,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modif.Cnp) = $event)),
                                  label: "CNP",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.DocIdentIssuer,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modif.DocIdentIssuer) = $event)),
                                  label: "Emitent",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.modif.MrtStatus,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.modif.MrtStatus) = $event)),
                                  items: _ctx.mrtItems,
                                  label: "Stare civilă",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": "",
                                  clearable: ""
                                }, null, 8, ["modelValue", "items"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.DocIdentIssueDate,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.modif.DocIdentIssueDate) = $event)),
                                  label: "Data eliberării",
                                  type: "date",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.DocIdentExpiryDate,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.modif.DocIdentExpiryDate) = $event)),
                                  label: "Data expirării",
                                  type: "date",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panel, { value: "adresa" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_54, [
                                _createVNode(_component_v_icon, { size: "15" }, {
                                  default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                    _createTextVNode("mdi-map-marker-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _cache[77] || (_cache[77] = _createElementVNode("span", { class: "pnl-title" }, "Adresă & contact", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Street,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.modif.Street) = $event)),
                                  label: "Stradă",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.StreetNr,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.modif.StreetNr) = $event)),
                                  label: "Nr.",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Block,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.modif.Block) = $event)),
                                  label: "Bloc",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Entrance,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.modif.Entrance) = $event)),
                                  label: "Scară",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Appartment,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.modif.Appartment) = $event)),
                                  label: "Apartament",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.CP,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.modif.CP) = $event)),
                                  label: "Cod poștal",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Phone,
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.modif.Phone) = $event)),
                                  label: "Telefon",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.Email,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.modif.Email) = $event)),
                                  label: "Email",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panel, { value: "bancar" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_56, [
                                _createVNode(_component_v_icon, { size: "15" }, {
                                  default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                    _createTextVNode("mdi-bank-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _cache[79] || (_cache[79] = _createElementVNode("span", { class: "pnl-title" }, "Date bancare & permis auto", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_57, [
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.modif.CardBankID,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.modif.CardBankID) = $event)),
                                  items: _ctx.banci,
                                  "item-title": "Nume",
                                  "item-value": "ID",
                                  label: "Bancă",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": "",
                                  clearable: ""
                                }, null, 8, ["modelValue", "items"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.CardAccNo,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.modif.CardAccNo) = $event)),
                                  label: "IBAN",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.CardNo,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.modif.CardNo) = $event)),
                                  label: "Nr. card",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.modif.DrvLicense,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.modif.DrvLicense) = $event)),
                                  label: "Permis auto",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.modifMsg)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: _ctx.modifMsgType,
                        variant: "tonal",
                        density: "compact",
                        class: "mt-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.modifMsg), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "modif-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.dialogModif = false))
                }, {
                  default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                    _createTextVNode("Închide", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: "btn-modif px-6",
                  loading: _ctx.modifLoading,
                  disabled: !_ctx.modif.Mesaj,
                  onClick: _ctx.trimiteModif
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                        _createTextVNode("mdi-send", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[82] || (_cache[82] = _createTextVNode("Trimite cererea ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}